@if (form) {
  <form class="action-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <span class="title">{{ dataContext.title | translate }}</span>
    <div class="form-group">
      <app-date-picker
        [form]="form"
        [title]="dataContext.fieldName"
        [model]="value"
        [helpText]="dataContext.helpText"
        [isRequired]="dataContext.mandatory"
      ></app-date-picker>
    </div>
    <div>
      <button class="btn btn-active" type="submit">{{ 'OK_BTN' | translate }}</button>
      <button class="btn link-btn ml-2" type="button" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
    </div>
  </form>
}
